module.exports = __webpack_public_path__ + "img/Go@3XC.c3eac396.png";